import React from "react";

import Navigation from "./components/Navigation";
import LoginCard from "./components/LoginCard";

const App = () => {
  return (
    <React.Fragment>
      <Navigation />
      <LoginCard />
    </React.Fragment>
  );
};

export default App;
